import { Layout } from "antd";
import clsx from "clsx";
import type { ComponentProps } from "react";
import "./BContent.scss";

type BContentProps = ComponentProps<typeof Layout.Content>;

const BContent = ({ className, ...props }: BContentProps) => (
  <Layout.Content className={clsx("b-content", className)} {...props} />
);

export default BContent;
